import { Spinner, Stack, useMediaQuery, Alert, AlertIcon, Text } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import MainCard from '../../../../components/MainCard/Index';
import { useGetOrCreateTitleSubmission } from '../../../../services/hooks/TitleSubmissions/useGetOrCreateTitleSubmission';
import TitleSubmissionContent from './TitleSubmissionContent';
import TitleSubmissionMobilePage from './TitleSubmissionMobilePage';

const TitleSubmissionArea: React.FC = () => {
  const [isMobile] = useMediaQuery('(max-width: 1024px)');
  const registrationId = useLocation().pathname.split('/')[2];
  const stepId = useLocation().pathname.split('/')[4];

  const { submission, isLoading, error, refetch } = useGetOrCreateTitleSubmission(
    registrationId,
    stepId
  );

  const content = (
    <>
      {isLoading && (
        <Stack align="center" justify="center" py={8}>
          <Spinner emptyColor="gray.100" color="blue.500" size="xl" />
          <Text fontSize="sm">Carregando prova de títulos...</Text>
        </Stack>
      )}
      {!isLoading && error && (
        <Alert status="error" borderRadius="md">
          <AlertIcon />
          <Text fontSize="sm">
            {(error as { response?: { data?: { detail?: string } } })?.response?.data?.detail ||
              'Erro ao carregar a prova de títulos. O período de envio pode estar encerrado.'}
          </Text>
        </Alert>
      )}
      {!isLoading && !error && submission && (
        <TitleSubmissionContent submission={submission} onRefetch={refetch} />
      )}
    </>
  );

  if (isMobile) {
    return <TitleSubmissionMobilePage>{content}</TitleSubmissionMobilePage>;
  }

  return (
    <MainCard title="ÁREA DO CANDIDATO" subtitle="- PROVA DE TÍTULOS">
      {content}
    </MainCard>
  );
};

export default TitleSubmissionArea;
